export const bonuses = [
  {
    num: '01',
    title: 'Quick Adaptation Kit',
    desc: 'Versions A, B and C for every exercise. One class that works for mixed-level groups.',
    value: '$12',
    image: 'https://cdn.magicpatterns.com/uploads/cCRS1jdTxEB2wmwFkGgLc8/bono_1.webp',
  },
  {
    num: '02',
    title: '20 Ready-to-Use Warm-Ups',
    desc: 'Session-specific warm-ups. Express and full-length versions.',
    value: '$9',
    image: 'https://cdn.magicpatterns.com/uploads/e3UQaJ7kB1p9pAeFhyuUZA/bono_2.webp',
  },
  {
    num: '03',
    title: '20 Cool-Downs & Class Closers',
    desc: 'End every class like a pro. Closing scripts included.',
    value: '$9',
    image: 'https://cdn.magicpatterns.com/uploads/peS4tz3JyZ1qNq3vbV5jwg/bono_3.webp',
  },
  {
    num: '04',
    title: '50 Coaching Phrases & Scripts',
    desc: 'The exact words to motivate, correct and lead your class.',
    value: '$8',
    image: 'https://cdn.magicpatterns.com/uploads/m2NPUUzwvPyrjzNFwwBH7u/bono_4.webp',
  },
  {
    num: '05',
    title: 'Master Planning Sheet',
    desc: 'Yearly, monthly, weekly and daily views. No more improvising.',
    value: '$12',
    image: 'https://cdn.magicpatterns.com/uploads/eowfsa6ChGrgJUUnJ9vCCd/bono_5.webp',
  },
]
